<template>
    <ul class="b2b-color-selector">
        <li class="b2b-color-selector__list-item"
            v-for="(color, index) in colors"
            :key="index">



            <label :for="`b2b-color-swatch-${color}`"
                class="b2b-color-selector__label">
                <input type="radio"
                    :aria-label="`${color} swatch`"
                    class="b2b-color-selector__color-check"
                    :data-color="color"
                    data-id="#"
                    data-url="#"
                    :id="`b2b-color-swatch-${color}`"
                    :name="radioName"
                    :value="color"
                    v-model="active"
                    @change="onChange">

                <span class="b2b-color-selector__color-decorator"
                    :class="`swatch-${color}`">
                </span>
            </label>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        activeColor: String,
        colors: Array,
        radioName: String,
    },
    data() {
        return {
            active: this.activeColor,
        }
    },
    methods: {
        onChange(event) {
            console.log('swatch selection changed')
        },
    },

}
</script>
